import {MessageCodes} from "../MessageCodes";
import {useAppContext} from "../../../context/AppContext";
import ResultView from "../../../components/ResultView";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import HecRasHelper from "../../../helpers/HecRasHelper";
import CheckCSName from "../CheckCSName";

const renderCounty = (group, idx) => {
    switch (group.position) {
        case 'us':
            return (
                <div key={idx}>
                    {group.county} (US of RS <CheckCSName csName={group.rs_boundary} csNameVal={group.rs_boundary}/>)
                </div>
            )
        case 'ds':
            return (
                <div key={idx}>
                    {group.county} (DS of RS <CheckCSName csName={group.rs_boundary} csNameVal={group.rs_boundary}/>)
                </div>
            )
        case 'between':
            return (
                <div key={idx}>
                    {group.county} (between RS <CheckCSName csName={group.rs_us} csNameVal={group.rs_us}/>
                    {' '}and RS <CheckCSName csName={group.rs_ds} csNameVal={group.rs_ds}/>)
                </div>
            )
        case 'single':
        default:
            return <div key={idx}>{group.county}</div>
    }
}

const countyText = (counties) => (counties || []).map(g => g.county).join(', ')

export function COV1({message_key}) {
    const {getSelectedHistory} = useAppContext()
    const summary = getSelectedHistory()?.summary
    const base = summary?.base
    const compare = summary?.compare

    const baseXY = base?.spatial_xy
    const cmpXY = compare?.spatial_xy

    const countiesDiffer = countyText(base?.counties) !== countyText(compare?.counties)

    return (
        <ResultView error_id={MessageCodes.Compare.COV01.error_id} message_key={message_key}>
            <ResultText>
                Location Information of base and comparison plans are tabulated below. The differences are highlighted in red.
            </ResultText>
            <EmptyLine/>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(25)}}/>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(25)}}>Base Plan</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(25)}}>Comparison Plan</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {(base?.counties?.length > 0 || compare?.counties?.length > 0) && (
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left'}}>County</ResultHeaderCell>
                            <ResultBodyCell style={{textAlign: 'right'}}>{base?.counties?.map(renderCounty)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'right', color: countiesDiffer ? 'red' : undefined}}>
                                {compare?.counties?.map(renderCounty)}
                            </ResultBodyCell>
                        </ResultRow>
                    )}
                    {(baseXY?.length === 2 || cmpXY?.length === 2) && (
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left'}}>Spatial Identifier</ResultHeaderCell>
                            <ResultBodyCell style={{textAlign: 'right'}}>({baseXY?.[0]}, {baseXY?.[1]})</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'right'}}>
                                ({ResultCellHighlight(baseXY?.[0], cmpXY?.[0])}, {ResultCellHighlight(baseXY?.[1], cmpXY?.[1])})
                            </ResultBodyCell>
                        </ResultRow>
                    )}
                </ResultBody>
            </ResultTable>
        </ResultView>
    )
}
